import { HttpClient, HttpHeaders } from "@angular/common/http"
import { BehaviorSubject, Observable, Subject, Subscription } from "rxjs"
import { ErrorService } from "src/app/error/err.service";
import { ToastService } from "../custom-overlay/toast/toast.service";
import { ToastType } from "../shared.enums";

enum ResponseStates {
    ResponseDefault = -1,
    RespondedPending = 0
}

export class LongPollingPromiseStatelessAPIManagement {

    private requestTimeout:any;
    private refreshInterval:number = 600000;
    private isProgress_:BehaviorSubject<boolean> = new BehaviorSubject(false);
    isProgress$ = this.isProgress_.asObservable();
    private isprogress:boolean = false;
    private stoppolling:boolean = false;
    private emitData:Promise<any>
    private subscription:Subscription = Subscription.EMPTY;
    private timeIntervalState:boolean = false;
    public responsestate:number = ResponseStates.ResponseDefault;
    private maxCount = 0;
    private token:string;
    private reject:Function;

    constructor(
        private requestmethod:Function,
        public http:HttpClient,
        private userloggedout:Observable<boolean>,
        private errorservice :ErrorService,
        private toastService: ToastService,
        private url:string,
        private moduleName:string,
    ){
        this.userloggedout.subscribe((val:any)=>{
            this.cancelRequest();
        });
    }

    toStringify(postData:any){
        return JSON.stringify(postData)
    }

    headers = new HttpHeaders({'content-type': 'application/json'})

    postrequest(requestobj:any){
        if(!this.isprogress){
            this.emitData = new Promise((resolve,reject)=>{
                this.isprogress = true;
                this.isProgress_.next(true);
                this.responsestate = 0;
                this.stoppolling = false;
                this.reject = reject;
                this.subscription = this.requestmethod(this.toStringify({"request_type": "handshake"})).subscribe((dat:any)=>{
                    if(dat){
                        this.token = dat.token;
                        this.startLongPolling({...requestobj,"token":dat.token,"request_type":dat.request_type},resolve,reject)
                    }else{
//console.log("request returned null")
                        this.errorReset();
                        reject({});
                    }
                },(err:any)=>{
                    this.errorReset()
                    reject(err)
                })
            })
        }
        return this.emitData;
    }

    startLongPolling(requestobj:any,resolve:Function,reject:Function){
        this.subscription = this.requestmethod(this.toStringify(requestobj)).subscribe((dat:any)=>{
            if(dat){
                if(dat.isData){
                    resolve(dat.res_obj);
                    this.responsestate = -1;
                    this.completeReset();
                }else if(dat.isError){
                    this.showError(dat.error.errmsg,'failure')
                    this.errorReset();
                    this.errorservice.postOnlineErrors(this.createErrorObject(dat,1,1),1);
                    reject(dat)
                }else{
                   this.continuousRequest({"token":dat.token,"request_type":dat.request_type},resolve,reject) 
                }
            }else{
//console.log("request returned null")
                this.errorReset();
                reject({});
            }
            
        })
    }

    continuousRequest(requestobj:any,resolve:Function,reject:Function){
        if(this.maxCount < 3 && !this.stoppolling){
            this.subscription = this.requestmethod(this.toStringify(requestobj)).subscribe((dat:any)=>{
                if(dat){
                    if(dat.isData){
                        resolve(dat.res_obj)
                        this.responsestate = -1;
                        this.completeReset();
                    }else if(dat.isError){
                        this.showError(dat.error.errmsg,'failure')
                        this.errorReset();
                        this.errorservice.postOnlineErrors(this.createErrorObject(dat,1,1),1);
                        reject(dat);
                    }else{
                        this.maxCount++;
                       this.continuousRequest({"token":dat.token,"request_type":dat.request_type},resolve,reject)
                    }
                }else{
//console.log("request returned null")
                    this.errorReset();
                    reject({});
                }
            })
        }else{
            this.cancelRequest()
            reject({error:{errmsg:"Server takes long time then expected"}});
            this.maxCount = 0;
            this.errorReset();
            this.showError('Server takes long time then expected','failure');
            this.errorservice.postOnlineErrors(this.createErrorObject('Maximum number of api request exceeded',1,0),1);
        }
        
    }

    completeReset(){
        this.isProgress_.next(false);
        this.isprogress = false;
        this.maxCount = 0;
    }

    errorReset(){
        this.responsestate = ResponseStates.ResponseDefault;
        this.isProgress_.next(false);
        this.isprogress = false;
    }

    showError(errormsg:string,type:string){
        this.toastService.ShowToaster(this.moduleName + " :" + errormsg, type);
    }

    createErrorObject(val:any,errorState:number,customstate:number){
        const errobj = this.errorservice.httpobjectBuilder(errorState,customstate,val);
        errobj.url = this.url;
        return errobj;
    }

    refresh(){
        this.isProgress_.next(false);
        this.clearReset();
        this.resetstoreddata();
    }

    resetstoreddata(){
        this.requestTimeout = setTimeout(()=>{
            this.timeIntervalState = false;
        },this.refreshInterval);
    }

    clearReset(){
        clearTimeout(this.requestTimeout)
    }

    cancelRequest(){
        this.isProgress_.next(false);
        this.subscription.unsubscribe();
        if(this.isprogress){
            this.isprogress = false;
            this.reject({});
            this.cancelCall();
            this.token = "";
            this.stoppolling = true;
        }
    }

    cancelCall(){
        let reqobj = {"token":this.token,"request_type":"cancel"}
        this.requestmethod(reqobj).subscribe((canceled)=>{})
    }

    getprogress(){
        return this.isprogress;
    }
}